import { render, staticRenderFns } from "./RemoteEducation.vue?vue&type=template&id=74ae9756&"
import script from "./RemoteEducation.vue?vue&type=script&lang=ts&"
export * from "./RemoteEducation.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteEducation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports